// extracted by mini-css-extract-plugin
export default {"servicesGrid":"servicesgrid_servicesGrid__qiGad"};